/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterCircularContentAddPost } from '../fn/circular-content/api-master-circular-content-add-post';
import { ApiMasterCircularContentAddPost$Params } from '../fn/circular-content/api-master-circular-content-add-post';
import { apiMasterCircularContentDeleteGet } from '../fn/circular-content/api-master-circular-content-delete-get';
import { ApiMasterCircularContentDeleteGet$Params } from '../fn/circular-content/api-master-circular-content-delete-get';
import { apiMasterCircularContentEditPost } from '../fn/circular-content/api-master-circular-content-edit-post';
import { ApiMasterCircularContentEditPost$Params } from '../fn/circular-content/api-master-circular-content-edit-post';
import { apiMasterCircularContentGetActiveGet } from '../fn/circular-content/api-master-circular-content-get-active-get';
import { ApiMasterCircularContentGetActiveGet$Params } from '../fn/circular-content/api-master-circular-content-get-active-get';
import { apiMasterCircularContentGetAllGet } from '../fn/circular-content/api-master-circular-content-get-all-get';
import { ApiMasterCircularContentGetAllGet$Params } from '../fn/circular-content/api-master-circular-content-get-all-get';
import { apiMasterCircularContentGetByCriteriaPost } from '../fn/circular-content/api-master-circular-content-get-by-criteria-post';
import { ApiMasterCircularContentGetByCriteriaPost$Params } from '../fn/circular-content/api-master-circular-content-get-by-criteria-post';
import { apiMasterCircularContentGetByIdGet } from '../fn/circular-content/api-master-circular-content-get-by-id-get';
import { ApiMasterCircularContentGetByIdGet$Params } from '../fn/circular-content/api-master-circular-content-get-by-id-get';
import { CircularContent } from '../models/circular-content';
import { CircularContentApiRespModel } from '../models/circular-content-api-resp-model';
import { StringApiRespModel } from '../models/string-api-resp-model';

@Injectable({ providedIn: 'root' })
export class CircularContentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterCircularContentAddPost()` */
  static readonly ApiMasterCircularContentAddPostPath = '/api/Master/CircularContent/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCircularContentAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCircularContentAddPost$Response(params?: ApiMasterCircularContentAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CircularContentApiRespModel>> {
    return apiMasterCircularContentAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCircularContentAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCircularContentAddPost(params?: ApiMasterCircularContentAddPost$Params, context?: HttpContext): Observable<CircularContentApiRespModel> {
    return this.apiMasterCircularContentAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CircularContentApiRespModel>): CircularContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterCircularContentEditPost()` */
  static readonly ApiMasterCircularContentEditPostPath = '/api/Master/CircularContent/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCircularContentEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCircularContentEditPost$Response(params?: ApiMasterCircularContentEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CircularContentApiRespModel>> {
    return apiMasterCircularContentEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCircularContentEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCircularContentEditPost(params?: ApiMasterCircularContentEditPost$Params, context?: HttpContext): Observable<CircularContentApiRespModel> {
    return this.apiMasterCircularContentEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CircularContentApiRespModel>): CircularContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterCircularContentDeleteGet()` */
  static readonly ApiMasterCircularContentDeleteGetPath = '/api/Master/CircularContent/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCircularContentDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCircularContentDeleteGet$Response(params?: ApiMasterCircularContentDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
    return apiMasterCircularContentDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCircularContentDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCircularContentDeleteGet(params?: ApiMasterCircularContentDeleteGet$Params, context?: HttpContext): Observable<StringApiRespModel> {
    return this.apiMasterCircularContentDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringApiRespModel>): StringApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterCircularContentGetAllGet()` */
  static readonly ApiMasterCircularContentGetAllGetPath = '/api/Master/CircularContent/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCircularContentGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCircularContentGetAllGet$Response(params?: ApiMasterCircularContentGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CircularContent>>> {
    return apiMasterCircularContentGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCircularContentGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCircularContentGetAllGet(params?: ApiMasterCircularContentGetAllGet$Params, context?: HttpContext): Observable<Array<CircularContent>> {
    return this.apiMasterCircularContentGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CircularContent>>): Array<CircularContent> => r.body)
    );
  }

  /** Path part for operation `apiMasterCircularContentGetActiveGet()` */
  static readonly ApiMasterCircularContentGetActiveGetPath = '/api/Master/CircularContent/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCircularContentGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCircularContentGetActiveGet$Response(params?: ApiMasterCircularContentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CircularContent>>> {
    return apiMasterCircularContentGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCircularContentGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCircularContentGetActiveGet(params?: ApiMasterCircularContentGetActiveGet$Params, context?: HttpContext): Observable<Array<CircularContent>> {
    return this.apiMasterCircularContentGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CircularContent>>): Array<CircularContent> => r.body)
    );
  }

  /** Path part for operation `apiMasterCircularContentGetByIdGet()` */
  static readonly ApiMasterCircularContentGetByIdGetPath = '/api/Master/CircularContent/GetById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCircularContentGetByIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCircularContentGetByIdGet$Response(params?: ApiMasterCircularContentGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CircularContent>> {
    return apiMasterCircularContentGetByIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCircularContentGetByIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCircularContentGetByIdGet(params?: ApiMasterCircularContentGetByIdGet$Params, context?: HttpContext): Observable<CircularContent> {
    return this.apiMasterCircularContentGetByIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CircularContent>): CircularContent => r.body)
    );
  }

  /** Path part for operation `apiMasterCircularContentGetByCriteriaPost()` */
  static readonly ApiMasterCircularContentGetByCriteriaPostPath = '/api/Master/CircularContent/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCircularContentGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCircularContentGetByCriteriaPost$Response(params?: ApiMasterCircularContentGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CircularContent>>> {
    return apiMasterCircularContentGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCircularContentGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCircularContentGetByCriteriaPost(params?: ApiMasterCircularContentGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<CircularContent>> {
    return this.apiMasterCircularContentGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CircularContent>>): Array<CircularContent> => r.body)
    );
  }

}
